'use client'

import { useState, useEffect } from 'react'
import Link from 'next/link'
import { T, detectLang, type Lang } from '../landingCopy'

export default function StatusFooter() {
  const [lang, setLang] = useState<Lang>('DE')
  const t = T[lang]
  const [status, setStatus] = useState<{ api: boolean; ai: boolean; pricesFresh: boolean; version: string } | null>(null)

  // Detect browser language on mount — DE for German browsers, EN otherwise.
  useEffect(() => { setLang(detectLang()) }, [])

  useEffect(() => {
    let cancelled = false
    const poll = async () => {
      try {
        const r = await fetch('/api/status', { cache: 'no-store' })
        if (!r.ok) throw new Error('bad')
        const d = await r.json()
        if (!cancelled) setStatus({ api: !!d.api, ai: !!d.ai, pricesFresh: !!d.pricesFresh, version: String(d.version || '') })
      } catch {
        if (!cancelled) setStatus({ api: false, ai: false, pricesFresh: false, version: '' })
      }
    }
    poll()
    // 5 min + only when the tab is visible — idle anonymous tabs previously
    // hit /api/status every 60s forever (function invocations + iPad battery).
    const id = setInterval(() => { if (document.visibilityState === 'visible') poll() }, 300_000)
    return () => { cancelled = true; clearInterval(id) }
  }, [])

  const dot = (ok: boolean) => (
    <span style={{ display: 'inline-block', width: 8, height: 8, borderRadius: '50%', background: ok ? '#10b981' : '#ef4444', boxShadow: ok ? '0 0 6px rgba(16,185,129,0.5)' : 'none', flexShrink: 0 }} />
  )

  return (
    <footer style={{ borderTop: '1px solid var(--color-border)' }}>
      <div style={{ maxWidth: 1120, margin: '0 auto', padding: '1rem 1.5rem', display: 'flex', alignItems: 'center', justifyContent: 'space-between', fontSize: '0.75rem', color: 'var(--color-text-muted)', flexWrap: 'wrap', gap: '0.75rem' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '1.25rem', flexWrap: 'wrap' }}>
          <span style={{ display: 'inline-flex', alignItems: 'center', gap: '0.4rem' }}>{dot(status?.api ?? false)}<span>{t.statusApi}</span></span>
          <span style={{ display: 'inline-flex', alignItems: 'center', gap: '0.4rem' }}>{dot(status?.ai ?? false)}<span>{t.statusAi}</span></span>
          <span style={{ display: 'inline-flex', alignItems: 'center', gap: '0.4rem' }}>{dot(status?.pricesFresh ?? false)}<span>{t.statusPrices}</span></span>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '1.25rem', flexWrap: 'wrap' }}>
          <span style={{ fontVariantNumeric: 'tabular-nums' }}>{t.versionLabel} {status?.version || '—'}</span>
          <div style={{ display: 'flex', gap: '0.875rem' }}>
            <Link href="/login" style={{ color: 'inherit', textDecoration: 'none' }}>Impressum</Link>
            <Link href="/login" style={{ color: 'inherit', textDecoration: 'none' }}>Datenschutz</Link>
            <Link href="/login" style={{ color: 'inherit', textDecoration: 'none' }}>AGB</Link>
          </div>
        </div>
      </div>
    </footer>
  )
}
